import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

interface UpdateUserParams {
  id: string
  role: string
  type?: 'user' | 'invitation'
}

export function useUpdateUserMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, role, type }: UpdateUserParams) => {
      const query: Record<string, string | number | boolean> = {}
      if (type) query.type = type

      await fetchApi({
        endpoint: `/api/users/update/${encodeURIComponent(id)}`,
        method: 'PUT',
        query,
        body: { role },
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['users', 'list'] })
    },
  })
}
